// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"6e0c2781","834":"3b2d1c42"}[chunkId] + ".chunk.js";
};